<template>
  <div
    id="app"
    :class="`${$alert._vm.list.length ? 'alert' : ''}`"
  >
    <!-- Global notifications -->
    <GlobalNotifications />

    <!-- LOGIN VIEW -->
    <div v-if="user === null">
      <Login />
    </div>

    <!-- ROUTER VIEW -->
    <router-view
      v-else-if="user && invitationTag !== undefined"
      :user="user"
      :invitationTag="invitationTag"
    />

    <!-- LOADING VIEW -->
    <div v-else class="loading">Loading</div>

    <!-- GLOBAL ALERTS -->
    <div class="vm-alerts-shadow" v-if="$alert._vm.list.length">
      <div
        v-for="alert in $alert._vm.list"
        :key="alert.id"
        class="active-vm-alert"
      >
        <div class="ct">
          <p>{{ alert.message }}</p>
        </div>
        <div class="ft">
          <div></div>
          <div style="padding: 10px;">
            <button @click.prevent="$dismissAlert(alert.id)">OK</button>
          </div>
        </div>
      </div>
    </div>

    <footer id="app-footer" style="margin-top: 1em">
      <strong>© GearCaster 2019</strong>
      <p>
        <router-link to="/privacy">Privacy Policy</router-link> | 
        <a href="https://discord.gg/BCCb6YG" target="_blank">
          Discord server
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import store from "store";
import MainLayout from "@/views/MainLayout";
import Login from "@/views/Login.vue";
import GlobalNotifications from "@/components/Home/GlobalNotifications.vue";

export default {
  components: { Login, GlobalNotifications },
  data: () => {
    return {
      user: {
        id: "guest",
        token: "guest",
        username: "guest",
        avatar: "who",
        cardIDs: [],
        claimedOn: undefined,
        configuredDecks: {},
        unopenedPacks: {},
        duelStats: {},
      },
      invitationTag: undefined,
      error: undefined,
      socket_reconnecting: false
    };
  },
  mounted() {
    this.authenticate();
  },
  watch: {
    "$route"($route) {
      this.invitationTag = $route.query.u || '';
    }
  },
  sockets: {
    connect() {
      this.authenticate();
    },
    reconnect_attempt() {
      this.socket_reconnecting = true;
    },
    connect_error() {
      this.socket_reconnecting = false;
    },
    userData(data) {
      if (data) {
        this.user = data;
        store.set("user", { token: data.token, username: data.username }); // this might be performance intensive
      } else {
        this.user = null;
      }
    }
  },
  methods: {
    attemptReconnect() {
      this.$socket.open();
      this.socket_reconnecting = true;
    },
    authenticate() {
      return console.log('authentication has been removed for now.');

      let credentials = store.get("user");

      if (!credentials) {
        this.user = null;
      } else {
        this.$socket.emit("user.authenticate", credentials, (err, data) => {
          if (err) {
            this.user = null;
            store.remove("user");
          }
        });
      }
    }
  }
};
</script>

<style>
@charset "UTF-8";
@font-face {
  font-family: "entypo";
  font-style: normal;
  font-weight: normal;
  src: url("/assets/entypo.eot");
  src: url("/assets/entypo.eot?#iefix") format("eot"),
    url("/assets/entypo.woff") format("woff"),
    url("/assets/entypo.ttf") format("truetype"),
    url("/assets/entypo.svg#entypo") format("svg");
}
#app {
  position: relative;
  padding-bottom: 2em;
}
#app-footer {
  position: fixed;
  background: rgba(255, 255, 255, 0.726);
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1em;
  font-size: small;
  z-index: 10000;
}
.entypo-note:before {
  content: "\266a";
}
.entypo-note-beamed:before {
  content: "\266b";
}
.entypo-music:before {
  content: "\1f3b5";
}
.entypo-search:before {
  content: "\1f50d";
}
.entypo-flashlight:before {
  content: "\1f526";
}
.entypo-mail:before {
  content: "\2709";
}
.entypo-heart:before {
  content: "\2665";
}
.entypo-heart-empty:before {
  content: "\2661";
}
.entypo-star:before {
  content: "\2605";
}
.entypo-star-empty:before {
  content: "\2606";
}
.entypo-user:before {
  content: "\1f464";
}
.entypo-users:before {
  content: "\1f465";
}
.entypo-user-add:before {
  content: "\e700";
}
.entypo-video:before {
  content: "\1f3ac";
}
.entypo-picture:before {
  content: "\1f304";
}
.entypo-camera:before {
  content: "\1f4f7";
}
.entypo-layout:before {
  content: "\268f";
}
.entypo-menu:before {
  content: "\2630";
}
.entypo-check:before {
  content: "\2713";
}
.entypo-cancel:before {
  content: "\2715";
}
.entypo-cancel-circled:before {
  content: "\2716";
}
.entypo-cancel-squared:before {
  content: "\274e";
}
.entypo-plus:before {
  content: "\2b";
}
.entypo-plus-circled:before {
  content: "\2795";
}
.entypo-plus-squared:before {
  content: "\229e";
}
.entypo-minus:before {
  content: "\2d";
}
.entypo-minus-circled:before {
  content: "\2796";
}
.entypo-minus-squared:before {
  content: "\229f";
}
.entypo-help:before {
  content: "\2753";
}
.entypo-help-circled:before {
  content: "\e704";
}
.entypo-info:before {
  content: "\2139";
}
.entypo-info-circled:before {
  content: "\e705";
}
.entypo-back:before {
  content: "\1f519";
}
.entypo-home:before {
  content: "\2302";
}
.entypo-link:before {
  content: "\1f517";
}
.entypo-attach:before {
  content: "\1f4ce";
}
.entypo-lock:before {
  content: "\1f512";
}
.entypo-lock-open:before {
  content: "\1f513";
}
.entypo-eye:before {
  content: "\e70a";
}
.entypo-tag:before {
  content: "\e70c";
}
.entypo-bookmark:before {
  content: "\1f516";
}
.entypo-bookmarks:before {
  content: "\1f4d1";
}
.entypo-flag:before {
  content: "\2691";
}
.entypo-thumbs-up:before {
  content: "\1f44d";
}
.entypo-thumbs-down:before {
  content: "\1f44e";
}
.entypo-download:before {
  content: "\1f4e5";
}
.entypo-upload:before {
  content: "\1f4e4";
}
.entypo-upload-cloud:before {
  content: "\e711";
}
.entypo-reply:before {
  content: "\e712";
}
.entypo-reply-all:before {
  content: "\e713";
}
.entypo-forward:before {
  content: "\27a6";
}
.entypo-quote:before {
  content: "\275e";
}
.entypo-code:before {
  content: "\e714";
}
.entypo-export:before {
  content: "\e715";
}
.entypo-pencil:before {
  content: "\270e";
}
.entypo-feather:before {
  content: "\2712";
}
.entypo-print:before {
  content: "\e716";
}
.entypo-retweet:before {
  content: "\e717";
}
.entypo-keyboard:before {
  content: "\2328";
}
.entypo-comment:before {
  content: "\e718";
}
.entypo-chat:before {
  content: "\e720";
}
.entypo-bell:before {
  content: "\1f514";
}
.entypo-attention:before {
  content: "\26a0";
}
.entypo-alert:before {
  content: "\1f4a5'";
}
.entypo-vcard:before {
  content: "\e722";
}
.entypo-address:before {
  content: "\e723";
}
.entypo-location:before {
  content: "\e724";
}
.entypo-map:before {
  content: "\e727";
}
.entypo-direction:before {
  content: "\27a2";
}
.entypo-compass:before {
  content: "\e728";
}
.entypo-cup:before {
  content: "\2615";
}
.entypo-trash:before {
  content: "\e729";
}
.entypo-doc:before {
  content: "\e730";
}
.entypo-docs:before {
  content: "\e736";
}
.entypo-doc-landscape:before {
  content: "\e737";
}
.entypo-doc-text:before {
  content: "\1f4c4";
}
.entypo-doc-text-inv:before {
  content: "\e731";
}
.entypo-newspaper:before {
  content: "\1f4f0";
}
.entypo-book-open:before {
  content: "\1f4d6";
}
.entypo-book:before {
  content: "\1f4d5";
}
.entypo-folder:before {
  content: "\1f4c1";
}
.entypo-archive:before {
  content: "\e738";
}
.entypo-box:before {
  content: "\1f4e6";
}
.entypo-rss:before {
  content: "\e73a";
}
.entypo-phone:before {
  content: "\1f4dE";
}
.entypo-cog:before {
  content: "\2699";
}
.entypo-tools:before {
  content: "\2692";
}
.entypo-share:before {
  content: "\e73c";
}
.entypo-shareable:before {
  content: "\e73e";
}
.entypo-basket:before {
  content: "\e73d";
}
.entypo-bag:before {
  content: "\1f45c'";
}
.entypo-calendar:before {
  content: "\1f4c5";
}
.entypo-login:before {
  content: "\e740";
}
.entypo-logout:before {
  content: "\e741";
}
.entypo-mic:before {
  content: "\1f3a4";
}
.entypo-mute:before {
  content: "\1f507";
}
.entypo-sound:before {
  content: "\1f50a";
}
.entypo-volume:before {
  content: "\e742";
}
.entypo-clock:before {
  content: "\1f554";
}
.entypo-hourglass:before {
  content: "\23f3";
}
.entypo-lamp:before {
  content: "\1f4a1";
}
.entypo-light-down:before {
  content: "\1f505";
}
.entypo-light-up:before {
  content: "\1f506";
}
.entypo-adjust:before {
  content: "\25d1";
}
.entypo-block:before {
  content: "\1f6ab";
}
.entypo-resize-full:before {
  content: "\e744";
}
.entypo-resize-small:before {
  content: "\e746";
}
.entypo-popup:before {
  content: "\e74c";
}
.entypo-publish:before {
  content: "\e74d";
}
.entypo-window:before {
  content: "\e74e";
}
.entypo-arrow-combo:before {
  content: "\e74f";
}
.entypo-down-circled:before {
  content: "\e758";
}
.entypo-left-circled:before {
  content: "\e759";
}
.entypo-right-circled:before {
  content: "\e75a";
}
.entypo-up-circled:before {
  content: "\e75b";
}
.entypo-down-open:before {
  content: "\e75c";
}
.entypo-left-open:before {
  content: "\e75d";
}
.entypo-right-open:before {
  content: "\e75e";
}
.entypo-up-open:before {
  content: "\e75f";
}
.entypo-down-open-mini:before {
  content: "\e760";
}
.entypo-left-open-mini:before {
  content: "\e761";
}
.entypo-right-open-mini:before {
  content: "\e762";
}
.entypo-up-open-mini:before {
  content: "\e763";
}
.entypo-down-open-big:before {
  content: "\e764";
}
.entypo-left-open-big:before {
  content: "\e765";
}
.entypo-right-open-big:before {
  content: "\e766";
}
.entypo-up-open-big:before {
  content: "\e767";
}
.entypo-down:before {
  content: "\2b07";
}
.entypo-left:before {
  content: "\2b05";
}
.entypo-right:before {
  content: "\27a1";
}
.entypo-up:before {
  content: "\2b06";
}
.entypo-down-dir:before {
  content: "\25be";
}
.entypo-left-dir:before {
  content: "\25c2";
}
.entypo-right-dir:before {
  content: "\25b8";
}
.entypo-up-dir:before {
  content: "\25b4";
}
.entypo-down-bold:before {
  content: "\e4b0";
}
.entypo-left-bold:before {
  content: "\e4ad";
}
.entypo-right-bold:before {
  content: "\e4ae";
}
.entypo-up-bold:before {
  content: "\e4af";
}
.entypo-down-thin:before {
  content: "\2193";
}
.entypo-left-thin:before {
  content: "\2190";
}
.entypo-right-thin:before {
  content: "\2192";
}
.entypo-up-thin:before {
  content: "\2191";
}
.entypo-ccw:before {
  content: "\27f2";
}
.entypo-cw:before {
  content: "\27f3";
}
.entypo-arrows-ccw:before {
  content: "\1f504";
}
.entypo-level-down:before {
  content: "\21b3";
}
.entypo-level-up:before {
  content: "\21b0";
}
.entypo-shuffle:before {
  content: "\1f500";
}
.entypo-loop:before {
  content: "\1f501";
}
.entypo-switch:before {
  content: "\21c6";
}
.entypo-play:before {
  content: "\25b6";
}
.entypo-stop:before {
  content: "\25a0";
}
.entypo-pause:before {
  content: "\2389";
}
.entypo-record:before {
  content: "\26ab";
}
.entypo-to-end:before {
  content: "\23ed";
}
.entypo-to-start:before {
  content: "\23ee";
}
.entypo-fast-forward:before {
  content: "\23e9";
}
.entypo-fast-backward:before {
  content: "\23ea";
}
.entypo-progress-0:before {
  content: "\e768";
}
.entypo-progress-1:before {
  content: "\e769";
}
.entypo-progress-2:before {
  content: "\e76a";
}
.entypo-progress-3:before {
  content: "\e76b";
}
.entypo-target:before {
  content: "\1f3af";
}
.entypo-palette:before {
  content: "\1f3a8";
}
.entypo-list:before {
  content: "\e005";
}
.entypo-list-add:before {
  content: "\e003";
}
.entypo-signal:before {
  content: "\1f4f6";
}
.entypo-trophy:before {
  content: "\1f3c6";
}
.entypo-battery:before {
  content: "\1f50b";
}
.entypo-back-in-time:before {
  content: "\e771";
}
.entypo-monitor:before {
  content: "\1f4bb";
}
.entypo-mobile:before {
  content: "\1f4f1";
}
.entypo-network:before {
  content: "\e776";
}
.entypo-cd:before {
  content: "\1f4bf";
}
.entypo-inbox:before {
  content: "\e777";
}
.entypo-install:before {
  content: "\e778";
}
.entypo-globe:before {
  content: "\1f30e";
}
.entypo-cloud:before {
  content: "\2601";
}
.entypo-cloud-thunder:before {
  content: "\26c8";
}
.entypo-flash:before {
  content: "\26a1";
}
.entypo-moon:before {
  content: "\263d";
}
.entypo-flight:before {
  content: "\2708";
}
.entypo-paper-plane:before {
  content: "\e79b";
}
.entypo-leaf:before {
  content: "\1f342";
}
.entypo-lifebuoy:before {
  content: "\e788";
}
.entypo-mouse:before {
  content: "\e789";
}
.entypo-briefcase:before {
  content: "\1f4bc";
}
.entypo-suitcase:before {
  content: "\e78e";
}
.entypo-dot:before {
  content: "\e78b";
}
.entypo-dot-2:before {
  content: "\e78c";
}
.entypo-dot-3:before {
  content: "\e78d";
}
.entypo-brush:before {
  content: "\e79a";
}
.entypo-magnet:before {
  content: "\e7a1";
}
.entypo-infinity:before {
  content: "\221e";
}
.entypo-erase:before {
  content: "\232b";
}
.entypo-chart-pie:before {
  content: "\e751";
}
.entypo-chart-line:before {
  content: "\1f4c8";
}
.entypo-chart-bar:before {
  content: "\1f4ca";
}
.entypo-chart-area:before {
  content: "\1f53e";
}
.entypo-tape:before {
  content: "\2707";
}
.entypo-graduation-cap:before {
  content: "\1f393";
}
.entypo-language:before {
  content: "\e752";
}
.entypo-ticket:before {
  content: "\1f3ab";
}
.entypo-water:before {
  content: "\1f4a6";
}
.entypo-droplet:before {
  content: "\1f4a7";
}
.entypo-air:before {
  content: "\e753";
}
.entypo-credit-card:before {
  content: "\1f4b3";
}
.entypo-floppy:before {
  content: "\1f4be";
}
.entypo-clipboard:before {
  content: "\1f4cb";
}
.entypo-megaphone:before {
  content: "\1f4e3";
}
.entypo-database:before {
  content: "\e754";
}
.entypo-drive:before {
  content: "\e755";
}
.entypo-bucket:before {
  content: "\e756";
}
.entypo-thermometer:before {
  content: "\e757";
}
.entypo-key:before {
  content: "\1f511";
}
.entypo-flow-cascade:before {
  content: "\e790";
}
.entypo-flow-branch:before {
  content: "\e791";
}
.entypo-flow-tree:before {
  content: "\e792";
}
.entypo-flow-line:before {
  content: "\e793";
}
.entypo-flow-parallel:before {
  content: "\e794";
}
.entypo-rocket:before {
  content: "\1f680";
}
.entypo-gauge:before {
  content: "\e7a2";
}
.entypo-traffic-cone:before {
  content: "\e7a3";
}
.entypo-cc:before {
  content: "\e7a5";
}
.entypo-cc-by:before {
  content: "\e7a6";
}
.entypo-cc-nc:before {
  content: "\e7a7";
}
.entypo-cc-nc-eu:before {
  content: "\e7a8";
}
.entypo-cc-nc-jp:before {
  content: "\e7a9";
}
.entypo-cc-sa:before {
  content: "\e7aa";
}
.entypo-cc-nd:before {
  content: "\e7ab";
}
.entypo-cc-pd:before {
  content: "\e7ac";
}
.entypo-cc-zero:before {
  content: "\e7ad";
}
.entypo-cc-share:before {
  content: "\e7ae";
}
.entypo-cc-remix:before {
  content: "\e7af";
}
.entypo-github:before {
  content: "\f300";
}
.entypo-github-circled:before {
  content: "\f301";
}
.entypo-flickr:before {
  content: "\f303";
}
.entypo-flickr-circled:before {
  content: "\f304";
}
.entypo-vimeo:before {
  content: "\f306";
}
.entypo-vimeo-circled:before {
  content: "\f307";
}
.entypo-twitter:before {
  content: "\f309";
}
.entypo-twitter-circled:before {
  content: "\f30a";
}
.entypo-facebook:before {
  content: "\f30c";
}
.entypo-facebook-circled:before {
  content: "\f30d";
}
.entypo-facebook-squared:before {
  content: "\f30e";
}
.entypo-gplus:before {
  content: "\f30f";
}
.entypo-gplus-circled:before {
  content: "\f310";
}
.entypo-pinterest:before {
  content: "\f312";
}
.entypo-pinterest-circled:before {
  content: "\f313";
}
.entypo-tumblr:before {
  content: "\f315";
}
.entypo-tumblr-circled:before {
  content: "\f316";
}
.entypo-linkedin:before {
  content: "\f318";
}
.entypo-linkedin-circled:before {
  content: "\f319";
}
.entypo-dribbble:before {
  content: "\f31b";
}
.entypo-dribbble-circled:before {
  content: "\f31c";
}
.entypo-stumbleupon:before {
  content: "\f31e";
}
.entypo-stumbleupon-circled:before {
  content: "\f31f";
}
.entypo-lastfm:before {
  content: "\f321";
}
.entypo-lastfm-circled:before {
  content: "\f322";
}
.entypo-rdio:before {
  content: "\f324";
}
.entypo-rdio-circled:before {
  content: "\f325";
}
.entypo-spotify:before {
  content: "\f327";
}
.entypo-spotify-circled:before {
  content: "\f328";
}
.entypo-qq:before {
  content: "\f32a";
}
.entypo-instagrem:before {
  content: "\f32d";
}
.entypo-dropbox:before {
  content: "\f330";
}
.entypo-evernote:before {
  content: "\f333";
}
.entypo-flattr:before {
  content: "\f336";
}
.entypo-skype:before {
  content: "\f339";
}
.entypo-skype-circled:before {
  content: "\f33a";
}
.entypo-renren:before {
  content: "\f33c";
}
.entypo-sina-weibo:before {
  content: "\f33f";
}
.entypo-paypal:before {
  content: "\f342";
}
.entypo-picasa:before {
  content: "\f345";
}
.entypo-soundcloud:before {
  content: "\f348";
}
.entypo-mixi:before {
  content: "\f34b";
}
.entypo-behance:before {
  content: "\f34e";
}
.entypo-google-circles:before {
  content: "\f351";
}
.entypo-vkontakte:before {
  content: "\f354";
}
.entypo-smashing:before {
  content: "\f357";
}
.entypo-sweden:before {
  content: "\f601";
}
.entypo-db-shape:before {
  content: "\f600";
}
.entypo-logo-db:before {
  content: "\f603";
}

[class*="entypo-"]:before {
  font-family: "entypo", sans-serif;
}

* {
  margin: 0;
  padding: 0;
  font-size: 100%;
  line-height: 1.5;
  /* use alternative box model */
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  height: 100%;
}

body {
  min-height: 100%;
}
html,
body {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-size: 14px;
  background: #c1cdc9 url(/assets/bg.png) repeat !important;
  color: #555;
  text-rendering: initial;
  -moz-osx-font-smoothing: auto;
}

#app {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-size: 14px;
}

/* clearfixing... in 2019... too stubborn to flexbox this */
.cf:before,
.cf:after {
  content: " ";
  display: table;
}

.cf:after {
  clear: both;
}

/* utility classes */
.fl {
  float: left;
}
.fr {
  float: right;
}
.one-third {
  width: 30%;
}
.flex {
  display: flex;
}
.faded {
  opacity: 0.6;
}
p.error {
  background: rgb(158, 0, 0);
  color: white;
  border-top: 1px solid red;
}
.warning {
  color: orange;
}

body {
  border-top: 5px solid #96a39f;
}

header {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 1px;
  color: #777;
}
.container {
  margin: 0 auto;
  max-width: 1380px;
}
.cobblebox {
  border-radius: 3px;
  border: 4px solid #808080;
  background: radial-gradient(circle, #4F4F4F 0%, #333 100%);
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.5);
  color: white;
  padding: 2px 5px;
}
.credit-display {
  border-radius: 6px;
  border: 3px solid #808080;
  background: radial-gradient(circle, #4F4F4F 0%, #333 100%);
  padding: 1px 5px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  margin-left: 5px;
  font-size: small;
}
.credit-display > span, strong, i, p {
  margin-right: 5px;
}
.credit-display > img {
  height: 13px;
  width: 13px;
}

.main-child-leave-active {
  transform: scale(0.8);
  opacity: 0.5;
  transition: .2s all ease-in-out;
  animation: 0.5s main-child-transition linear forwards;
}
.main-child-enter-active {
  transition: .2s all ease-in-out;
  animation: 1s main-child-transition reverse backwards;
}
@keyframes main-child-transition {
  90% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100vh);
    opacity: 0;
  }
}

.mainlayout-leave-active {
  transform: translateX(-100vh);
  opacity: 0;
  transition: .5s all ease-in-out;
}
.mainlayout-enter-active {
  transition: .8s all ease-in-out;
  animation: 1s main-child-transition reverse backwards;
}
button {
  font-weight: bold;
  border-radius: 4px;
  background: linear-gradient(#dbc25e, #a89548);
  color: white;
  padding: 5px 8px;
  display: block;
  width: 100%;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border: none;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  cursor: pointer;
  border: 1px solid #bda753;
  box-shadow: inset 0 0 3px rgba(255, 255, 255, 0.5),
    0 0 0 2px rgba(255, 255, 255, 0.35);
  transition: all 0.1s;
}
button:hover {
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.8),
    0 0 0 2px rgba(255, 255, 255, 0.35);
}
button:active {
  background: linear-gradient(#bda753, #bda753);
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.6),
    0 0 0 2px rgba(255, 255, 255, 0.5);
}
button:disabled {
  background: #aeb8b5;
  border-color: rgb(158, 158, 158);
  box-shadow: none;
  cursor: not-allowed;
}
button:disabled:hover {
  background: #aeb8b5;
  border-color: rgb(158, 158, 158);
  box-shadow: none;
}

button.urgent-button {
  background: linear-gradient(#db775e, #a84e48);
  border: 1px solid #bd7153;
}
button.urgent-button:active {
  background: #bd6353;
}
button.light {
  background: linear-gradient(white, #E0E0E0);
  border: 2px solid #828282;
  box-shadow: 0 0 5px 0 rgba(255,255,255,0.8);
  color: #333;
}
button.light:hover {
  box-shadow: inset 0 0 5px rgba(219, 219, 219, 0.8),
    0 0 0 2px rgba(255, 255, 255, 0.35);
}
.ml-title {
  position: relative;
  z-index: 10;
  border-radius: 9px;
  border: 4px solid #808080;
  font-weight: bold;
  text-align: center;
}
.loading {
  font-size: 14px;

  text-align: center;
  padding: 30px;
  border-radius: 12px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  margin: 30px 60px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.error-box {
  width: 100%;
  border: 2px solid #af4033;
  border-radius: 5px;
  background: #fce3e4;
  padding: 1rem;
  color: #af4033;
}
.error-box p {
  margin-bottom: 1rem;
}
input[type="text"],
textarea,
input[type="email"] {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
  padding: 5px 12px;
  font-size: 16px;
  border-radius: 4px;
  margin: 6px 0;
  transition: all 0.3 ease-in-out;
}
input:focus,
input:active,
textarea:active,
textarea:focus {
  border-color: rgb(17, 92, 190);
  box-shadow: 0 0 0 2px rgba(17, 92, 190, 0.3);
}

.r-health {
  color: rgb(255, 83, 83);
}
.r-gears {
  color: rgb(215, 216, 149);
}
.r-springs {
  color: rgb(0, 183, 255);
}
.r-energy {
  color: rgb(60, 255, 0);
}
.b-health {
  background: rgba(255, 181, 181, 0.7);
  color: rgb(114, 11, 11);
}
.b-gears {
  background: rgba(215, 216, 149, 0.7);
  color: rgb(84, 85, 4);
}
.b-springs {
  background: rgba(156, 227, 255, 0.7);
  color: rgb(8, 58, 78);
}
.b-energy {
  background: rgba(197, 255, 179, 0.7);
  color: rgb(22, 77, 5);
}
#app.alert {
  overflow: hidden;
  height: 100vh;
}
.vm-alerts-shadow {
  position: absolute;
  top: -5px;
  height: 100vh;
  left: 0;
  right: 0;
  background: rgba(128, 128, 128, 0.822);
  z-index: 100000;
}
.active-vm-alert {
  width: 300px;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  box-shadow: 2px 2px 2px grey;
  overflow: hidden;
  z-index: 100;
  margin: auto auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 150px;
  display: flex;
  flex-direction: column;
}
.active-vm-alert .ct {
  height: 100%;
  display: flex;
  flex-direction: columns;
  align-items: center;
  justify-content: center;
  min-height: 75px;
  padding: 1em;
  text-align: center;
  overflow: hidden;
}
.active-vm-alert .ft {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background: #c1cdc9;
}
.active-vm-alert .ft > div {
  flex: 1;
}
.chatMessage-token > * {
  display: inline;
}
</style>
